/*
 * Favorieten alleen met een account (besluit Thomas, 5 nov 2026).
 *
 * Een gast die op een hartje, 'Bewaar' of het favorietenfilter tikt, krijgt dit venster: inloggen of een account
 * aanmaken. De klik zelf vangt een klein script in de head van layout/theme.liquid af, vóór alle andere luisteraars
 * (ook die van sentir-favorieten.js, die op document in de capture-fase luistert). Dit bestand:
 *   1. zet na het inloggen de geur waarop de gast tikte alsnog in de favorieten (sessionStorage 'sentir-fav-wacht',
 *      hooguit 30 minuten oud), met de gewone melding van sentir-favorieten.js;
 *   2. bouwt het venster (zelfde vorm als het lijstvenster .sentir-blad);
 *   3. toont op de favorietenpagina een inlogkaart in plaats van lijsten (niet bij een gedeelde lijst, ?gedeeld=).
 * Teksten: eigen nl/de/fr/en per subdomein, op nl/de/fr afgeschermd voor Weglot (huisregel).
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var klant = html.getAttribute('data-sentir-klant') || '';
  var WACHT = 'sentir-fav-wacht';
  var MAX_OUD = 30 * 60 * 1000;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var taal = (function () {
    var host = window.location.hostname;
    if (/^nl\./.test(host)) return 'nl';
    if (/^de\./.test(host)) return 'de';
    if (/^fr\./.test(host)) return 'fr';
    return 'en';
  })();

  var TEKSTEN = {
    nl: {
      titel: 'Bewaar je favorieten',
      tekst: 'Log in of maak gratis een account aan. Dan bewaren we je favorieten en vind je ze terug op al je apparaten.',
      product: 'Daarna staat {naam} meteen in je favorieten.',
      inloggen: 'Inloggen',
      account: 'Account aanmaken',
      sluiten: 'Sluiten',
      paginaTitel: 'Log in om je favorieten te zien',
      paginaTekst: 'Je favorieten, lijsten en notities bewaren we in je account. Zo vind je ze terug op al je apparaten.',
    },
    de: {
      titel: 'Speichere deine Favoriten',
      tekst: 'Melde dich an oder erstelle kostenlos ein Konto. Dann speichern wir deine Favoriten und du findest sie auf all deinen Geräten wieder.',
      product: 'Danach ist {naam} sofort in deinen Favoriten.',
      inloggen: 'Anmelden',
      account: 'Konto erstellen',
      sluiten: 'Schließen',
      paginaTitel: 'Melde dich an, um deine Favoriten zu sehen',
      paginaTekst: 'Deine Favoriten, Listen und Notizen speichern wir in deinem Konto. So findest du sie auf all deinen Geräten wieder.',
    },
    fr: {
      titel: 'Enregistrez vos favoris',
      tekst: 'Connectez-vous ou créez gratuitement un compte. Nous enregistrons vos favoris et vous les retrouvez sur tous vos appareils.',
      product: '{naam} sera ensuite aussitôt dans vos favoris.',
      inloggen: 'Se connecter',
      account: 'Créer un compte',
      sluiten: 'Fermer',
      paginaTitel: 'Connectez-vous pour voir vos favoris',
      paginaTekst: 'Nous enregistrons vos favoris, listes et notes dans votre compte. Vous les retrouvez ainsi sur tous vos appareils.',
    },
    en: {
      titel: 'Save your favourites',
      tekst: "Log in or create a free account. We'll save your favourites so you can find them on all your devices.",
      product: '{naam} will then be in your favourites straight away.',
      inloggen: 'Log in',
      account: 'Create account',
      sluiten: 'Close',
      paginaTitel: 'Log in to see your favourites',
      paginaTekst: 'We keep your favourites, lists and notes in your account, so you can find them on all your devices.',
    },
  };

  function t(sleutel) {
    return (TEKSTEN[taal] && TEKSTEN[taal][sleutel]) || TEKSTEN.en[sleutel] || '';
  }

  /* Op nl/de/fr onze eigen tekst, afgeschermd voor Weglot; op .com mag Weglot het Engels vertalen (es/it/ru). */
  function afschermen(el) {
    if (taal !== 'en') {
      el.setAttribute('data-wg-notranslate', '');
      el.classList.add('wg-notranslate');
    }
  }

  function leesWacht() {
    try {
      var w = JSON.parse(window.sessionStorage.getItem(WACHT) || 'null');
      return w && typeof w === 'object' ? w : null;
    } catch (fout) {
      return null;
    }
  }

  /* ---------------------------------------------- 1. na het inloggen -- */

  if (klant) {
    var wacht = leesWacht();
    if (!wacht) return;
    try { window.sessionStorage.removeItem(WACHT); } catch (fout) {}
    var pid = String(wacht.pid || '');
    if (!/^\d{1,20}$/.test(pid) || !(Date.now() - Number(wacht.t || 0) < MAX_OUD)) return;
    var pogingen = 0;
    (function bewaar() {
      var api = window.SentirFavorieten;
      if (!api) {
        if (++pogingen < 50) window.setTimeout(bewaar, 200);
        return;
      }
      if (!api.isFavoriet(pid)) {
        var handle = /^[a-z0-9-]{1,120}$/.test(wacht.handle || '') ? wacht.handle : '';
        api.zet(pid, true, { handle: handle, naam: String(wacht.naam || '').slice(0, 120) });
      }
      // De Lijst houdt zijn hartjes in het geheugen; zo leest hij ze opnieuw in.
      try { window.dispatchEvent(new CustomEvent('sentir:lists-sync')); } catch (fout) {}
    })();
    return;
  }

  /* De vanger in de head zet deze klasse; zonder vanger (uit, of in proefmodus niet aangezet) doen we niets. */
  if (!html.classList.contains('sentir-fav-gast')) return;

  /* ---------------------------------------------------- 2. het venster -- */

  var HART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3 4.6 13a4.9 4.9 0 0 1 0-7 4.9 4.9 0 0 1 6.9 0l.5.5.5-.5a4.9 4.9 0 0 1 6.9 0 4.9 4.9 0 0 1 0 7Z"/></svg>';
  var KRUIS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function terugPad() {
    // Zonder de proefschakelaar, zodat de link na het inloggen gewoon de pagina is.
    var zoek = window.location.search.replace(/([?&])fav_account=[01](&|$)/, '$1').replace(/[?&]$/, '');
    return window.location.pathname + zoek;
  }

  function loginUrl() {
    var basis = (window.routes && window.routes.account_login_url) || root + 'account/login';
    return basis + (basis.indexOf('?') > -1 ? '&' : '?') + 'checkout_url=' + encodeURIComponent(terugPad());
  }

  function registerUrl() {
    var basis = (window.routes && window.routes.account_register_url) || root + 'account/register';
    return basis + (basis.indexOf('?') > -1 ? '&' : '?') + 'return_to=' + encodeURIComponent(terugPad());
  }

  /* Welke geur hoort bij de knop: een Lijst-kaart, een accessoirekaart of het hartje op de productpagina. */
  function productVan(knop) {
    var uit = { pid: '', handle: '', naam: '' };
    if (!knop || !knop.closest) return uit;
    var kaart = knop.closest('.pcard, .card[data-product]');
    if (kaart) {
      uit.pid = kaart.getAttribute('data-card') || kaart.getAttribute('data-product') || '';
      uit.handle = kaart.getAttribute('data-handle') || kaart.getAttribute('data-gedeeld-handle') || '';
      var naamEl = kaart.querySelector('.nm');
      uit.naam = kaart.getAttribute('data-title') || (naamEl ? naamEl.textContent : '');
    } else if (knop.classList.contains('sentir-pdp-hart')) {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (meta) {
        uit.pid = String(meta.id || '');
        uit.handle = meta.handle || '';
      }
      var titel = knop.closest('[id="product-page-title"], .product__title, .bundle-product__title');
      uit.naam = titel ? titel.textContent : '';
    }
    uit.pid = /^\d{1,20}$/.test(uit.pid) ? uit.pid : '';
    uit.naam = String(uit.naam || '').replace(/\s+/g, ' ').trim();
    return uit;
  }

  function knoppenHtml() {
    return '<div class="sfa__knoppen">' +
      '<a class="sfa__knop sfa__knop--hoofd" data-sfa-login></a>' +
      '<a class="sfa__knop" data-sfa-account></a>' +
    '</div>';
  }

  function vulKnoppen(el) {
    var login = el.querySelector('[data-sfa-login]');
    var account = el.querySelector('[data-sfa-account]');
    login.textContent = t('inloggen');
    login.href = loginUrl();
    account.textContent = t('account');
    account.href = registerUrl();
  }

  var venster = null;
  var paneel = null;
  var opener = null;
  var huidig = null;

  function bouw() {
    venster = document.createElement('div');
    venster.className = 'sfa';
    venster.hidden = true;
    afschermen(venster);
    venster.innerHTML =
      '<div class="sfa__achter" data-sfa-dicht></div>' +
      '<div class="sfa__paneel" role="dialog" aria-modal="true" aria-labelledby="sfa-titel" aria-describedby="sfa-tekst">' +
        '<div class="sfa__kop">' +
          '<span class="sfa__icoon">' + HART + '</span>' +
          '<button type="button" class="sfa__sluit" data-sfa-dicht>' + KRUIS + '</button>' +
        '</div>' +
        '<h2 class="sfa__titel" id="sfa-titel"></h2>' +
        '<p class="sfa__tekst" id="sfa-tekst"></p>' +
        '<p class="sfa__product" hidden></p>' +
        knoppenHtml() +
      '</div>';
    paneel = venster.querySelector('.sfa__paneel');
    venster.querySelector('.sfa__titel').textContent = t('titel');
    venster.querySelector('.sfa__tekst').textContent = t('tekst');
    venster.querySelector('.sfa__sluit').setAttribute('aria-label', t('sluiten'));
    document.body.appendChild(venster);

    venster.addEventListener('click', function (event) {
      if (event.target.closest('[data-sfa-dicht]')) {
        sluit();
        return;
      }
      if (event.target.closest('[data-sfa-login], [data-sfa-account]')) onthoud();
    });
    venster.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        sluit();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusbaar = Array.prototype.filter.call(paneel.querySelectorAll('a[href], button'), function (el) {
        return !el.hidden && el.offsetParent !== null;
      });
      if (!focusbaar.length) return;
      var eerste = focusbaar[0];
      var laatste = focusbaar[focusbaar.length - 1];
      if (event.shiftKey && document.activeElement === eerste) {
        event.preventDefault();
        laatste.focus();
      } else if (!event.shiftKey && document.activeElement === laatste) {
        event.preventDefault();
        eerste.focus();
      }
    });
  }

  /* Vlak voor het inloggen of aanmelden: welke geur na terugkomst alsnog bewaard moet worden. */
  function onthoud() {
    if (!huidig || !huidig.pid) return;
    try {
      window.sessionStorage.setItem(WACHT, JSON.stringify({ pid: huidig.pid, handle: huidig.handle, naam: huidig.naam, t: Date.now() }));
    } catch (fout) {}
  }

  function open(knop) {
    if (!venster) bouw();
    opener = knop && knop.focus ? knop : document.activeElement;
    huidig = productVan(knop);
    var regel = venster.querySelector('.sfa__product');
    if (huidig.pid && huidig.naam) {
      var delen = t('product').split('{naam}');
      regel.textContent = '';
      regel.appendChild(document.createTextNode(delen[0] || ''));
      var naam = document.createElement('strong');
      naam.textContent = huidig.naam;
      regel.appendChild(naam);
      regel.appendChild(document.createTextNode(delen[1] || ''));
      regel.hidden = false;
    } else {
      regel.hidden = true;
    }
    vulKnoppen(venster);
    venster.hidden = false;
    html.classList.add('sfa-open', 'sentir-blad-open');
    window.requestAnimationFrame(function () {
      venster.classList.add('is-open');
      var hoofd = venster.querySelector('[data-sfa-login]');
      if (hoofd) hoofd.focus({ preventScroll: true });
    });
  }

  function sluit() {
    if (!venster || venster.hidden) return;
    venster.classList.remove('is-open');
    venster.hidden = true;
    html.classList.remove('sfa-open', 'sentir-blad-open');
    huidig = null;
    if (opener && opener.isConnected && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }

  window.SentirFavAccount = { open: open, sluit: sluit };

  // Tikken van vóór dit script (de vanger in de head zette ze opzij): het venster voor de laatste.
  var wachtrij = window.SentirFavAccountWacht || [];
  window.SentirFavAccountWacht = [];
  if (wachtrij.length) open(wachtrij[wachtrij.length - 1]);

  /* ------------------------------------- 3. favorietenpagina voor een gast -- */

  var pagina = document.querySelector('[data-favpage]');
  if (pagina && !/[?&]gedeeld=/.test(window.location.search)) {
    var kop = pagina.querySelector('.scl-favhd');
    var kaart = document.createElement('div');
    kaart.className = 'sfa-kaart';
    afschermen(kaart);
    kaart.innerHTML =
      '<span class="sfa__icoon">' + HART + '</span>' +
      '<h2 class="sfa__titel"></h2>' +
      '<p class="sfa__tekst"></p>' +
      knoppenHtml();
    kaart.querySelector('.sfa__titel').textContent = t('paginaTitel');
    kaart.querySelector('.sfa__tekst').textContent = t('paginaTekst');
    vulKnoppen(kaart);
    if (kop) kop.insertAdjacentElement('afterend', kaart);
    else pagina.insertBefore(kaart, pagina.firstChild);
    html.classList.add('sfa-favpagina');
  }
})();
